import { render, staticRenderFns } from "./zone-footer.vue?vue&type=template&id=de655f5e&scoped=true"
import script from "./zone-footer.vue?vue&type=script&lang=js"
export * from "./zone-footer.vue?vue&type=script&lang=js"
import style0 from "./zone-footer.vue?vue&type=style&index=0&id=de655f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de655f5e",
  null
  
)

export default component.exports